import React, { memo } from 'react';
import { Button } from 'js/components/common/Button';
import buildClassName from 'js/utils/classNameBuilder.util';

import style from './TableLoadMore.scss';

export const TableLoadMore = memo(({ classNames, title, onClick, disabled }) => (
    <div className={buildClassName(['loadMoreContainer'], style, classNames)}>
        <Button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={buildClassName(['loadMoreBtn'], style, classNames)}
        >
            {title}
        </Button>
    </div>
));
